// Native Web Share API with WhatsApp fallback.
// Shares the TrigoTour app URL to any contact/app the user picks.
import { toast } from "sonner";

const APP_URL = "https://tour.trigoride.com";
const APP_MESSAGE = "Découvrez TrigoTour 🚕 — location de véhicules avec chauffeurs à Yaoundé. Réservez en 2 clics :";

export async function shareApp() {
  const shareData = {
    title: "TrigoTour · Location & VTC",
    text: APP_MESSAGE,
    url: APP_URL,
  };
  // Native Web Share (mobile-first, opens the system chooser: WhatsApp, SMS, Messenger, …)
  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share(shareData);
      return { method: "native", ok: true };
    } catch (err) {
      if (err && err.name === "AbortError") return { method: "native", ok: false, aborted: true };
      // Fall through to WhatsApp fallback below
    }
  }
  // Fallback: open WhatsApp compose window
  const waUrl = `https://wa.me/?text=${encodeURIComponent(`${APP_MESSAGE} ${APP_URL}`)}`;
  window.open(waUrl, "_blank", "noopener,noreferrer");
  return { method: "whatsapp", ok: true };
}

export async function copyAppLink() {
  try {
    await navigator.clipboard.writeText(`${APP_MESSAGE} ${APP_URL}`);
    toast.success("Lien copié dans le presse-papier");
    return true;
  } catch {
    toast.error("Impossible de copier le lien");
    return false;
  }
}
